import { render, staticRenderFns } from "./redEnvelopeRainSuecces.vue?vue&type=template&id=63bd9ebe&scoped=true"
import script from "./redEnvelopeRainSuecces.vue?vue&type=script&lang=js"
export * from "./redEnvelopeRainSuecces.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/redEnvelopeRainSuecces.less?vue&type=style&index=0&id=63bd9ebe&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bd9ebe",
  null
  
)

export default component.exports